/**
 * Navigation breadcrumb for local debugging ("page does nothing").
 *
 * Must not write user identifiers, email, tokens, or request bodies.
 * Those values are visible in the browser console (screenshare, support)
 * and become Sentry breadcrumbs when a DSN exists.
 *
 * `[Route]` prefix is kept: archived operator notes grep for it.
 * Payload is path only.
 */

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "@/state/AuthContext";

export function RouteLogger() {
  const location = useLocation();
  // Read auth so a restored identifier log (user.id / organizationId / email)
  // is observable to the gating test. Do not put those values in console output.
  useAuth();
  const prevPathRef = useRef("");

  useEffect(() => {
    if (prevPathRef.current === location.pathname) {
      return;
    }
    prevPathRef.current = location.pathname;
    console.log("[Route]", { route: location.pathname });
  }, [location.pathname]);

  return null;
}
